import type { FeedbackMessage } from "@stockline/shared/types/core/feedback"
import type { OfflineResourceConfig } from "../../../types"
import { FEEDBACK_MESSAGE_TABLE } from "./db"

export const feedbackMessageConfig: OfflineResourceConfig<FeedbackMessage> = {
  name: "feedback-messages",
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/feedback-messages",
    delta: "/api/v2/feedback-messages/changes",
    push: "/api/v2/feedback-messages/changes",
  },
  tableName: FEEDBACK_MESSAGE_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    feedbackId: "feedbackId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
